import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from "react";
import { motion, useTransform, useViewportScroll, useSpring } from 'framer-motion';
import { directions } from "./animationConstants";

export default function SlideOnScroll(
  { children,
    classes,
    triggerPoints,
    direction = directions.LTR,
    length = 50,
    opacityChange = true,
    positionChange = true,
    sizeChange = false,
    reference = null }) {

  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];
  const { LTR, RTL, BTT } = directions;

  const setValues = () => {
    setElementTop(reference ? reference.current.offsetTop : ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const getScrollValue = (trigger) => {
    return elementTop - clientHeight * trigger;
  };

  let yL = useSpring(useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [0 - length, 0], easing), { damping: 50, stiffness: 500 });
  let yR = useSpring(useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [length, 0], easing), { damping: 50, stiffness: 500 });
  let y = useSpring(useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [length, 0], easing), { damping: 50, stiffness: 500 });
  const opacity = useSpring(useTransform(scrollY, [getScrollValue(triggerPoints[0]), getScrollValue(triggerPoints[1])], [0, 1], easing), { damping: 50, stiffness: 500 });

  let style = {};
  if (direction === LTR && opacityChange && positionChange) {
    style = { x: yL, opacity };
  } else if (direction === RTL && opacityChange && positionChange) {
    style = { x: yR, opacity };
  } else if (direction === BTT && opacityChange && positionChange) {
    style = { y, opacity };
  } else if (opacityChange && !positionChange) {
    style = { opacity };
  } else if (sizeChange && !opacityChange && !positionChange) {
    style = { scale: opacity };
  }

  if (!elementTop) {
    //console.log('error fetching element top');
    style = {};
  }
  //console.log('style in HOC: ', style);
  return (
    <motion.div ref={ref} className={classes} style={style} onLoad={setValues}>
      {children}
    </motion.div>
  );
}